// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__14ba9","intro":"styles_intro__nEtrl","nav":"styles_nav__VNxWM"};